<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.dwh_settings.form.server')"
            :is-required="true"
            :error="errorsData.server"
            :hint="__('settings.dwh_settings.form.server_hint')"
        >
            <DInput
                id="server"
                v-model="form.server"
                :placeholder="__('settings.dwh_settings.form.server')"
                :is-valid="isFormFieldValid('server')"
                maxlength="128"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.dwh_settings.form.database')"
            :is-required="true"
            :error="errorsData.database"
            :hint="__('settings.dwh_settings.form.database_hint')"
        >
            <DInput
                id="database"
                v-model="form.database"
                :placeholder="__('settings.dwh_settings.form.database')"
                :is-valid="isFormFieldValid('database')"
                maxlength="30"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.dwh_settings.form.port')"
            :is-required="true"
            :error="errorsData.port"
            :hint="__('settings.dwh_settings.form.port_hint')"
        >
            <DInput
                id="port"
                v-model="form.port"
                :placeholder="__('settings.dwh_settings.form.port')"
                :is-valid="isFormFieldValid('port')"
                type="number"
                max="65535"
                min="0"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.dwh_settings.form.username')"
            :is-required="true"
            :error="errorsData.username"
            :hint="__('settings.dwh_settings.form.username_hint')"
        >
            <DInput
                id="username"
                v-model="form.username"
                :placeholder="__('settings.dwh_settings.form.username')"
                :is-valid="isFormFieldValid('username')"
                maxlength="64"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.dwh_settings.form.password')"
            :is-required="dwhSettings === null"
            :error="errorsData.password"
            :hint="__('settings.dwh_settings.form.password_hint')"
        >
            <DInput
                id="password"
                v-model="form.password"
                :placeholder="__('settings.dwh_settings.form.password')"
                :is-valid="isFormFieldValid('password')"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.dwh_settings.form.table_name')"
            :is-required="true"
            :error="errorsData.table_name"
            :hint="__('settings.dwh_settings.form.table_name_hint')"
        >
            <DInput
                id="table_name"
                v-model="form.table_name"
                :placeholder="__('settings.dwh_settings.form.table_name')"
                :is-valid="isFormFieldValid('table_name')"
                maxlength="255"
            />
        </DFormRow>
        <DRow>
            <DCol sm="4" />
            <DCol sm="4">
                <div
                    v-if="dbConnectionStatus === 'successful'"
                    class="green-text"
                >
                    {{ __('settings.dwh_settings.connection_successful') }}
                </div>
                <div
                    v-if="dbConnectionStatus === 'unsuccessful'"
                    class="red-text"
                >
                    {{ __('settings.dwh_settings.connection_unsuccessful') }}
                </div>
            </DCol>
            <DCol
                sm="4"
                class="check-database-connection-btn"
            >
                <DButton
                    icon="lan-connect"
                    :label="__('settings.dwh_settings.check_database_connection')"
                    :disabled="isInLoadingState"
                    @click="checkDbConnection"
                />
            </DCol>
        </DRow>
        <DFormControls
            :dirty="form.isDirty"
            @submit="submitForm"
        />
        <DConnectionErrorModal
            :show-modal="connectionException !== null"
            :exception="connectionException"
            @close-modal="closeErrorCheckModal"
        />
    </DForm>
</template>

<script>

import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal'

export default {
    name: 'DwhSettingsForm',
    components: { DConnectionErrorModal },
    props: {
        dwhSettings: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                server: this.dwhSettings?.server ?? null,
                database: this.dwhSettings?.database ?? null,
                port: this.dwhSettings?.port ?? null,
                username: this.dwhSettings?.username ?? null,
                password: this.dwhSettings?.password ?? null,
                table_name: this.dwhSettings?.table_name ?? null
            }),
            connectionStatus: '',
            dbConnectionStatus: '',
            connectionException: null,
            error: null,
            errorsData: this.errors
        }
    },
    methods: {
        submitForm () {
            this.$emit('form-submitted', this.form)
        },
        checkConnection () {
            const self = this
            window.axios.post(this.$route('settings.dwh-settings.check', this.form))
                .then(function () {
                    self.connectionStatus = 'successful'
                })
                .catch(function () {
                    self.connectionStatus = 'unsuccessful'
                })
        },
        checkDbConnection () {
            this.errorsData = {}
            const self = this
            self.connectionException = null
            window.axios.post(this.$route('settings.dwh-settings.db-check', this.form))
                .then(function () {
                    self.dbConnectionStatus = 'successful'
                })
                .catch(function (error) {
                    self.dbConnectionStatus = 'unsuccessful'
                    if (error.response.data.error !== undefined) {
                        self.error = error.response.data.error
                    }
                    if (error.response.data.errors !== undefined) {
                        self.errorsData = error.response.data.errors

                        for (const key in self.errorsData) {
                            if (typeof self.errorsData[key] === 'object') {
                                self.errorsData[key] = self.errorsData[key][0]
                            }
                        }
                    }
                    if (error?.response.data.exception !== undefined) {
                        self.connectionException = error?.response.data.exception
                    }
                })
        },
        closeErrorCheckModal () {
            this.connectionException = null
            this.error = null
        }
    }
}
</script>

<style lang="scss" scoped>
.check-database-connection-btn {
    text-align: right;
    padding-bottom: 12px;
}
.green-text {
    color: green;
}
.red-text {
    color: red;
}
</style>
